var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcTimer = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.01 8A6.01 6.01 0 1 1 1.991 8 6.01 6.01 0 0 1 14.01 8ZM8.327 4.23a.333.333 0 1 0-.667 0V8c0 .184.15.333.333.333h3.02a.333.333 0 0 0 0-.666H8.327V4.229Z",
  fill: "#F74F2A"
})));
export default SvgIcTimer;